import type { Action, Resource, Role } from './types';
import { role } from './types';

export const toPermissionKey = (r: Resource, a: Action) => `${r}:${a}`;

export const hasPermission = (permissions: string[], r: Resource, a: Action) =>
  permissions.includes(toPermissionKey(r, a));

export const hasRole = (roles: string[], target: Role) =>
  roles.includes(target);

export const isAdmin = (roles: string[]) => hasRole(roles, role.admin);

// `system` is the cross-organisation super-user (org switching, org init). It
// deliberately carries no resource permissions — see the `system: []` note in
// apps/auth/api/src/auth/rbac.ts — so surfaces that must admit it have to check
// the role, not a permission.
export const isSystem = (roles: string[]) => hasRole(roles, role.system);

// The gate for admin-only tooling that the super-user must also reach.
export const isAdminOrSystem = (roles: string[]) =>
  isAdmin(roles) || isSystem(roles);
